import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { userCookie } from '~/models/UserCookie'

const RequireLogin = (Component) => (props) => {
  const isUserLoggedIn = userCookie.isLoggedIn
  const router = useRouter()
  useEffect(() => {
    if (!isUserLoggedIn) {
      const { pathname } = router
      router.replace({
        pathname: '/sign-in',
        query: { redirect: pathname },
      })
    }
  }, [isUserLoggedIn])

  if (!isUserLoggedIn) {
    return null
  }
  return <Component {...props} />
}

export default RequireLogin
